import type { CadastroCotaUsuarioEmAndamento } from "../cadastroPropriedadeV2/cadastroCotaUsuario.api";

export interface PropriedadeListada {
  icone: string;
  id: number;
  cotaUsuarioId: number | null;
  cadastroCotaUsuarioId?: number;
  key: string;
  empreend: string;
  nomeCidade: string;
  numeroCota: number | string;
  capacidade: number | string;
  aptoNome?: string;
  infoApt?: string;
  prioridade?: string;
  created_at: string;
  status: string;
  situacao: string;
}

export function combinarPropriedadesECadastros(
  propriedades: PropriedadeListada[],
  cadastros: CadastroCotaUsuarioEmAndamento[] | null
): PropriedadeListada[] {
  const emAndamento = (cadastros ?? []).filter(
    (cadastro) => !cadastro.concluidoEm && cadastro.etapaAtual !== "CONCLUIDO"
  );
  const cotasEmAndamento = new Set(
    emAndamento.map((cadastro) => cadastro.cotaUsuarioId).filter((id) => id != null)
  );
  const propriedadesPorCota = new Map(
    propriedades.map((propriedade) => [propriedade.cotaUsuarioId, propriedade])
  );

  const linhasCadastros = emAndamento.map((cadastro): PropriedadeListada => {
    const propriedade = cadastro.cotaUsuarioId == null
      ? undefined
      : propriedadesPorCota.get(cadastro.cotaUsuarioId);
    const cidade = cadastro.Empreendimento?.CidadeTable;
    const cotaUsuario = cadastro.CotaUsuario;
    const infoApt = [cotaUsuario?.bloco, cotaUsuario?.numeroApto]
      .filter(Boolean)
      .join(" - ");

    return {
      ...propriedade,
      id: cadastro.id,
      key: `cadastro-${cadastro.id}`,
      cadastroCotaUsuarioId: cadastro.id,
      cotaUsuarioId: cadastro.cotaUsuarioId,
      empreend: cadastro.Empreendimento?.nome || propriedade?.empreend || "Não definido",
      nomeCidade: cidade
        ? `${cidade.nome} - ${cidade.EstadoTab.abreviacao}`
        : propriedade?.nomeCidade || "Não definida",
      numeroCota: cadastro.Cota?.numeroCota ?? propriedade?.numeroCota ?? "Não definida",
      capacidade: cadastro.Apto?.capacidade ?? propriedade?.capacidade ?? "Não definida",
      aptoNome: cadastro.Apto?.nome || propriedade?.aptoNome || "Não definido",
      infoApt: infoApt || propriedade?.infoApt || "Não definido",
      prioridade: cotaUsuario?.prioridade || propriedade?.prioridade || "Não definida",
      created_at: cadastro.created_at,
      status: cadastro.etapaAtual,
      icone: "Cadastro em andamento",
      situacao: propriedade?.situacao || "Não definida",
    };
  });

  return [
    ...linhasCadastros,
    ...propriedades
      .filter((propriedade) => !cotasEmAndamento.has(propriedade.cotaUsuarioId))
      .map((propriedade) =>
        cadastros === null
          ? propriedade
          : {
              ...propriedade,
              status: "CONCLUIDO",
              icone: "Cadastro concluído",
            }
      ),
  ];
}
